import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import Image from "next/image";
import Creative from "../public/favicon/Creative.jpg";
import Cookies from "js-cookie";
import dayjs from "dayjs";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dynamic from "next/dynamic"; // Import dynamic from next/dynamic
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CounsellingModal from "../pages/CounsellingModal"; // Import CounsellingModal
import LoginPromptModal from "../components/homes/heros/LoginPromptModal";
// Dynamically import Calendar from antd
const Calendar = dynamic(() => import("antd/es/calendar"), { ssr: false });

dayjs.extend(customParseFormat);

// Function to disable past dates and Sundays
const disabledDate = (current) => {
  return current && (current < dayjs().startOf("day") || current.day() === 0);
};

// Time Slot Picker Component with 2-hour restriction logic for the current day
const TimeSlotPicker = ({ onTimeSelect, selectedDate }) => {
  const timeSlots = [
    "09:00 AM",
    "10:00 AM",
    "11:00 AM",
    "12:00 PM",
    "01:00 PM",
    "02:00 PM",
    "03:00 PM",
    "04:00 PM",
    "05:00 PM",
  ];

  const [currentTimePlus2Hours, setCurrentTimePlus2Hours] = useState(dayjs());
  const [selectedTime, setSelectedTime] = useState(null);

  useEffect(() => {
    if (selectedDate && dayjs(selectedDate).isSame(dayjs(), "day")) {
      setCurrentTimePlus2Hours(dayjs().add(2, "hour"));
    } else {
      setCurrentTimePlus2Hours(dayjs().startOf("day"));
    }
  }, [selectedDate]);

  const isTimeSlotAvailable = (slot) => {
    const slotTime = dayjs(slot, "hh:mm A");
    return selectedDate && dayjs(selectedDate).isSame(dayjs(), "day")
      ? slotTime.isAfter(currentTimePlus2Hours)
      : true;
  };

  const handleTimeClick = (time) => {
    setSelectedTime(time);
    const time24Format = dayjs(time, "hh:mm A").format("HH:mm:ss");
    onTimeSelect(time, time24Format); // Notify the parent
    // Display success message
    toast.success(`Time slot selected: ${time}`);
  };
  return (
    <div className="time-slot-picker-container p-2">
      <div className="time-slot-list flex flex-col gap-2 items-center">
        {timeSlots.map((slot, index) => {
          const available = isTimeSlotAvailable(slot);
          return (
            <button
              key={index}
              className={`w-full max-w-xs py-2 rounded-lg  text-base sm:text-lg font-medium ${
                selectedTime === slot
                  ? "bg-[#D6F5D6] text-gray-800"
                  : available
                  ? "bg-[#A9E5A9] text-gray-800"
                  : "bg-gray-300 text-gray-500"
              } ${
                available ? "hover:bg-[#C7ECC7] hover:text-gray-800" : ""
              } transition-all`}
              onClick={() => available && handleTimeClick(slot)}
              disabled={!available}
            >
              {slot}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export const BookSession = ({
  selectedCollege,
  selectedCounselling,
  selectedCourse,
  cardDetails, // Receive card details as props
}) => {
  const isPGCounselling = (() => {
    try {
      const title = selectedCounselling?.title?.toLowerCase() || "";
      const location = selectedCounselling?.location?.toLowerCase() || "";
      return title.includes("pg") || location.includes("pg");
    } catch (err) {
      return false;
    }
  })();

  const [isLoginPromptOpen, setIsLoginPromptOpen] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isDateSelected, setIsDateSelected] = useState(false);
  const [isTimeSlotSelected, setIsTimeSlotSelected] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedCollegeData, setSelectedCollegeData] =
    useState(selectedCollege);
  const [selectedCounsellingData, setSelectedCounsellingData] =
    useState(selectedCounselling);
  const [selectedCourseData, setSelectedCourseData] = useState(selectedCourse);
  const [isMentorInfoVisible, setIsMentorInfoVisible] = useState(true);

  const [isSessionBooked, setIsSessionBooked] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    neetScore: "",
    neetRank: "",
    location: "Noida",
    category: "OBC",
  });

  const handleTimeClick = (time) => {
    setSelectedTime(time);
    const time24Format = dayjs(time, "hh:mm A").format("HH:mm:ss");
  };

  const handleStartCounselling = () => {
    const title = encodeURIComponent(
      selectedCounselling?.title || selectedCollege?.title
    );
    const location = encodeURIComponent(
      selectedCounselling?.location ||
        selectedCollege?.location ||
        "Unknown Location"
    );
    localStorage.setItem("counsellingTitle", title);
    localStorage.setItem("counsellingLocation", location);

    if (authToken) {
      window.location.href = `https://portal.neetsupport.com/dashboard-Counselling?title=${title}&location=${location}`;
    } else {
      setIsLoginPromptOpen(true);
    }
  };

  const handleLoginSuccess = () => {
    const title = localStorage.getItem("counsellingTitle");
    const location = localStorage.getItem("counsellingLocation");
    window.location.href = `https://portal.neetsupport.com/dashboard-Counselling?title=${title}&location=${location}`;
  };

  const getCookie = (name) => {
    if (typeof window === "undefined") return null; // Ensure this runs on the client-side
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  };

  const [selectedDate, setSelectedDate] = useState(null);
  const [displayTime, setDisplayTime] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false); // State to control modal visibility
  const [isCounsellingModalOpen, setIsCounsellingModalOpen] = useState(false); // State to control CounsellingModal visibility
  const router = useRouter();
  const API_URL = process.env.NEXT_PUBLIC_API_URL;
  const authToken = getCookie("authToken");
  const isLoggedIn =
    process.env.NEXT_PUBLIC_NODE_ENV === "development" ||
    !!Cookies.get("authToken");

  const handleBookNow = () => {
    if (!isLoggedIn) {
      setIsCounsellingModalOpen(true);
    } else {
      setIsCounsellingModalOpen(true); // Open the CounsellingModal
    }
  };

  const handleClosePrompt = () => {
    setShowLoginPrompt(false);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleMobileChange = (e) => {
    let value = e.target.value;

    // Remove all non-numeric characters except the "+" symbol
    value = value.replace(/[^\d+]/g, "");

    // Check if the input starts with "+91"
    if (value.startsWith("+91")) {
      if (value.length > 13) {
        toast.error("Mobile number should be to 10 digits");
        return; // Prevent further processing
      }
      value = value.slice(0, 13); // Ensure the mobile number is not longer than "+91" + 10 digits
    } else {
      if (value.length > 10) {
        toast.error("Mobile number should be 10 digits");
        return; // Prevent further processing
      }
      value = `+91${value.slice(0, 10)}`; // Add "+91" if not present and limit to 10 digits
    }

    // Update the formData state with the corrected value
    setFormData((prev) => ({ ...prev, mobile: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.neetScore > 720) {
      toast.error("Score should be less than or equal to 720");
      return;
    }
    setIsFormSubmitted(true); // Hide form and mentor info, show calendar
  };

  const handleDateSelect = (date) => {
    setSelectedDate(dayjs(date).format("YYYY-MM-DD")); // Save selected date
    toast.success(`Date selected: ${dayjs(date).format("YYYY-MM-DD")}`);
  };

  const handleTimeSelect = (displayTime, time) => {
    setSelectedTime(time);
    toast.success("Time slot selected successfully");
  };

  const handleConfirmBooking = async () => {
    try {
      const payload = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        mobile: formData.mobile.startsWith("+91")
          ? formData.mobile // Keep as is if already starts with +91
          : `+91${formData.mobile.replace(/\D/g, "")}`, // Prepend +91 if not present

        // Ensure the mobile number is prefixed with "+91"
        neetScore: formData.neetScore.toString(), // Convert score to string
        neetRank: formData.neetRank.toString(), // Convert rank to string
        location: formData.location,
        category: formData.category,
        date: selectedDate, // Date already in "YYYY-MM-DD" format
        time: dayjs(selectedTime, "hh:mm A").format("HH:mm:ss"), // Format time to "HH:mm:ss"
        cardDetails, // Include card details in the payload
      };

      // Send the formatted payload to the server
      await axios.post(`${API_URL}/api/book-session`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      toast.success("Session booked successfully!");
      setIsSessionBooked(true); // Show success message
    } catch (error) {
      toast.error("Failed to book session");
    }
  };

  // Automatically close the success UI after 5 seconds
  useEffect(() => {
    if (isSessionBooked) {
      const timer = setTimeout(() => {
        setIsSessionBooked(false);
        setIsFormSubmitted(false);
        setIsDateSelected(false);
        setIsTimeSlotSelected(false);
        setIsModalOpen(false); // Close the modal
      }, 5000); // 5 seconds

      // Cleanup timer if component unmounts
      return () => clearTimeout(timer);
    }
  }, [isSessionBooked]);

  const handleBack = () => {
    if (selectedTime) {
      // Reset time selection to go back to Time Slot Picker
      setSelectedTime(null);
    } else if (selectedDate) {
      // If no time is selected, go back to date selection
      setSelectedDate(null);
    } else {
      // If no date is selected, go back to form
      setIsFormSubmitted(false);
    }
  };

  const renderInputField = (label, name, type = "text", placeholder = "") => (
    <div className="flex flex-col">
      <label className=" mb-1 text-white text-sm sm:text-base">{label}</label>
      <input
        className="w-full px-4 py-2 rounded bg-white text-gray-800 text-sm sm:text-base"
        placeholder={placeholder}
        name={name}
        value={formData[name]}
        onChange={name === "mobile" ? handleMobileChange : handleChange}
        type={type}
        required
      />
    </div>
  );

  const handleRankPredictor = async () => {
    window.location.href = "/neet-rank-predictor";
  };
  const handleCollegePredictor = async () => {
    window.location.href = "/neet-college-predictor";
  };
  const renderSelectField = (label, name, options) => (
    <div className="flex flex-col">
      <label className="text-white mb-1 text-sm sm:text-base">{label}</label>
      <select
        name={name}
        className="w-full px-4 py-2 rounded bg-white text-gray-800 text-sm sm:text-base"
        value={formData[name]}
        onChange={handleChange}
      >
        {options.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );

  return (
    <div>
      {!isPGCounselling && (
        <>
          <div className="bg-white border border-gray-200 rounded-lg p-4 mb-4">
            <h2 className="font-bold text-lg text-center mb-2">
              Predict Your Rank Now
            </h2>
            <p className="text-sm text-gray-600 mb-4 text-center">
              Enter your NEET score to get an estimated rank
            </p>
            <button
              onClick={handleRankPredictor}
              className="animate-blink bg-[#FF9245] text-white hover:ring-1 hover:ring-[#ff9245] rounded-full px-4 py-2 w-full hover:bg-[#fff] hover:!text-[#ff9245] transition-colors"
            >
              Rank Predictor
            </button>
          </div>

          <div className="bg-white border border-gray-200 rounded-lg p-4">
            <h2 className="font-bold text-lg text-center mb-2">
              Find the Best Colleges For You
            </h2>
            <p className="text-sm text-gray-600 mb-4 text-center">
              Based on your NEET rank, Category & more
            </p>
            <button
              onClick={handleCollegePredictor}
              className="animate-blink bg-[#FF9245] text-white hover:ring-1 hover:ring-[#ff9245] rounded-full px-4 py-2 w-full hover:bg-[#fff] hover:!text-[#ff9245] transition-colors"
            >
              Try College Predictor
            </button>
          </div>
        </>
      )}

      {/* Main Book Session Component */}

      <div className="bg-white border border-gray-200 rounded-lg p-4 mt-4">
        <ToastContainer />
        {/* Panda Image */}
        <div className="flex justify-center mb-4">
          <div className="relative sm:w-28 sm:h-28 md:w-full md:h-auto">
            <img
              src={Creative.src} // Use .src to get the correct path
              alt="Counselling"
              width={400} // Set width manually
              height={400} // Set height manually
              className="rounded-lg object-contain mx-auto"
            />
          </div>
        </div>

        {/* Title */}
        <h2 className="font-bold text-lg text-center mb-2">
          Get Your Dream Medical College
        </h2>

        {/* Description */}
        <p className="text-sm text-gray-600 mb-4 text-center">
          Secure your seat with expert counselling
        </p>

        {/* Conditional Buttons */}
        {selectedCollege ? (
          <button
            onClick={handleBookNow}
            className="animate-blink bg-[#FF9245] text-white hover:ring-1 hover:ring-[#ff9245] rounded-full px-4 py-2 w-full hover:bg-[#fff] hover:!text-[#ff9245] transition-colors"
          >
            Book Now
          </button>
        ) : (
          <button
            onClick={() => {
              handleStartCounselling();
            }}
            className="animate-blink bg-[#FF9245] text-white hover:ring-1 hover:ring-[#ff9245] rounded-full px-4 py-2 w-full hover:bg-[#fff] hover:!text-[#ff9245] transition-colors"
          >
            Start Counselling
          </button>
        )}

        {/* Counselling Modal */}
        <CounsellingModal
          isOpen={isCounsellingModalOpen}
          onClose={() => setIsCounsellingModalOpen(false)}
          college={selectedCollege || null}
          counselling={selectedCounselling || null}
          course={
            selectedCollege?.courseOffered ||
            selectedCounselling?.courseOffered ||
            []
          } // ✅ Ensure course is passed
        />

        {/* Login Prompt Modal */}
        {isLoginPromptOpen && (
          <LoginPromptModal
            onClose={() => setIsLoginPromptOpen(false)}
            onLoginSuccess={handleLoginSuccess}
            title={localStorage.getItem("counsellingTitle")}
            location={localStorage.getItem("counsellingLocation")}
            tag="Counselling"
          />
        )}

        {/* Booking Modal */}
        {/* {isModalOpen && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50 p-4 overflow-y-auto">
          <div className="w-full max-w-lg lg:max-w-5xl mx-4 rounded-lg shadow-lg relative overflow-hidden mt-16 max-h-screen bg-white">
            {isSessionBooked ? (
              <div className="success-screen min-h-[400px] flex-grow flex justify-center items-center p-10 bg-[#097F78] rounded-lg">
                <div className="text-center">
                  <div className="checkmark">
                    <i className="fas fa-check-circle fa-5x text-white"></i>
                  </div>
                  <h1 className="success-message text-2xl font-bold mt-4 text-[#50C878]">
                    Your Request is Submitted
                    </h1>
                  <p className="text-md text-white mt-2">
                    We will send you the session details on your email.
                  </p>
                </div>
              </div>
            ) : (
              <>
                {(isFormSubmitted || isDateSelected || isTimeSlotSelected) && (
                  <button
                    onClick={handleBack}
                    className="absolute top-1 left-1 text-white bg-[#ff9245] rounded-full w-8 h-8 flex items-center justify-center shadow-md cursor-pointer z-10"
                  >
                    ←
                  </button>
                )}

                <button
                  onClick={() => setIsModalOpen(false)}
                  className="absolute top-1 right-1 bg-[#ff9245] text-white rounded-full w-8 h-8 flex items-center justify-center font-bold transition duration-300 shadow-lg z-10"
                  aria-label="Close"
                >
                  ✕
                </button>

                <div className="flex flex-col lg:flex-row lg:space-x-8 p-2 sm:p-4 md:p-6 max-h-[70vh] overflow-y-auto">
                  {!isFormSubmitted && (
                    <div className="w-full pt-4 md:pt-2 md:pl-10 flex flex-col justify-center items-center">
                      <div className="w-full">
                        <h3 className="text-xl sm:text-2xl font-semibold mb-6 text-center text-[#097F78]">
                          Book Your <br />
                          <span className="text-[#FF9245]">1-on-1</span>
                          <br /> Session with Our Mentor
                        </h3>
                        <div className="border-b-2 border-[#B7804A] mb-3"></div>
                        <p className="font-bold text-[#097F78] text-center text-sm sm:text-base">
                          What to Expect from Your Session
                        </p>
                        <ul className="text-gray-700 space-y-1 text-sm sm:text-lg list-disc pl-5 text-left">
                          <li>Personalized Counseling</li>
                          <li>Document Verification</li>
                          <li>Expert Insights</li>
                          <li>Doubt Clearing</li>
                          <li>Motivation and Support</li>
                        </ul>
                      </div>
                    </div>
                  )}

                  <div className="w-full bg-[#097F78] p-6 rounded-xl flex flex-col justify-center items-center">
                    {!isFormSubmitted ? (
                      <>
                        <h3 className="text-xl sm:text-2xl font-semibold mb-2 text-center text-white">
                          Book your Session Now
                        </h3>
                        <form
                          onSubmit={handleSubmit}
                          className="space-y-2 w-full"
                        >
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            {renderInputField(
                              "First Name",
                              "firstName",
                              "text",
                              "First Name"
                            )}
                            {renderInputField(
                              "Last Name",
                              "lastName",
                              "text",
                              "Last Name"
                            )}
                          </div>
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            {renderInputField(
                              "Email ID",
                              "email",
                              "email",
                              "Email ID"
                            )}
                            {renderInputField(
                              "Mobile No.",
                              "mobile",
                              "tel",
                              "+91XXXXXXXXXX"
                            )}
                          </div>
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            {renderInputField(
                              "NEET Score",
                              "neetScore",
                              "number",
                              "NEET Score"
                            )}
                            {renderInputField(
                              "NEET Rank",
                              "neetRank",
                              "number",
                              "NEET Rank"
                            )}
                          </div>
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            {renderSelectField("Location", "location", [
                              "Online",
                            ])}
                            {renderSelectField("Category", "category", [
                              "OBC",
                              "General",
                              "SC/ST",
                            ])}
                          </div>
                          <div className="flex justify-center mt-4">
                            <button
                              type="submit"
                              className="bg-[#FF9245] px-4 py-2 rounded-3xl text-white font-medium text-sm sm:text-base transition"
                            >
                              Book Your Session Now
                            </button>
                          </div>
                        </form>
                      </>
                    ) : (
                      <>
                        <div className="w-full lg:w-[800px] bg-[#097F78] p-6 rounded-xl flex flex-col lg:flex-row lg:space-x-8 items-start">
                          <div className="w-full lg:w-1/2 flex flex-col items-center">
                            <h3 className="text-xl sm:text-2xl font-semibold mb-4 text-center text-white">
                              Select a Date
                            </h3>
                            <DatePicker
                              selected={selectedDate}
                              onChange={(date) => handleDateSelect(date)}
                              filterDate={(date) => {
                                const day = dayjs(date);
                                return (
                                  (day.isSame(dayjs(), "day") ||
                                    day.isAfter(dayjs().startOf("day"))) &&
                                  day.day() !== 0
                                );
                              }}
                              dateFormat="yyyy-MM-dd"
                              inline
                              calendarClassName="custom-calendar"
                            />
                          </div>

                          <div
                            className="hidden lg:block border-l mt-10 border-[#FF9245]"
                            style={{ height: "350px" }}
                          ></div>

                          <div className="w-full lg:w-1/2 flex flex-col items-center">
                            <h3 className="text-xl sm:text-2xl font-semibold mb-4 text-center text-white">
                              {selectedTime
                                ? "Time Selected"
                                : "Select a Time Slot"}
                            </h3>
                            {selectedTime ? (
                              <div className="flex flex-col items-center">
                                <div className="bg-white p-4 rounded-lg border border-[#FF9245] text-center w-full max-w-md">
                                  <p className="text-lg font-medium text-[#097F78]">
                                    Time slot selected: {selectedTime}
                                  </p>
                                </div>

                                <div className="flex justify-center mt-4">
                                  <button
                                    onClick={handleConfirmBooking}
                                    className="bg-[#FF9245] px-6 py-2 rounded-full text-white font-medium hover:bg-[#ff7b1e] transition"
                                  >
                                    Confirm Booking
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <div className="overflow-y-auto max-h-60 w-full scrollbar-hide">
                                <TimeSlotPicker
                                  onTimeSelect={(time) => setSelectedTime(time)}
                                  selectedDate={selectedDate}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      )} */}
      </div>
    </div>
  );
};
